import {ReactComponent as Save } from '../../graphicalContent/saveLogo.svg'
import './saveLogo.css'

export const SaveLogo = () => {
  return (
    <section className='SaveLogo'><Save />
    </section>
  )
}
